// Redux/Reducer/storeReducer.js

const initialState = {
  selectedStore: null,
};

export default function storeReducer(state = initialState, action) {
  switch (action.type) {
    case "SET_SELECTED_STORE":
      return { ...state, selectedStore: action.payload };
    default:
      return state;
  }
}
